// Mock data para a landing page da família Martins Ribeiro

export const familyData = {
  name: "Família Martins Ribeiro",
  location: "Goiânia, Goiás",
  established: "1956",
  founder: "Luziano Martins Ribeiro",
  story: {
    title: "Nossa História",
    content: "Fundada em 1956 por Luziano Martins Ribeiro, nossa família construiu um legado sólido no coração de Goiás. Começando com uma pequena empresa familiar, crescemos através de décadas de dedicação, trabalho árduo e visão empreendedora. Hoje, o Grupo Martins Ribeiro é uma holding que gerencia diversas empresas consolidadas no mercado goiano, sempre mantendo os valores familiares de integridade, qualidade e compromisso com a excelência.",
    values: [
      "Tradição familiar desde 1978",
      "Compromisso com a excelência",
      "Inovação e crescimento sustentável",
      "Valores éticos e transparência"
    ]
  }
};

export const companies = [
  {
    id: 1,
    name: "Mega Moda Shopping",
    category: "Varejo",
    description: "Centro comercial de referência em Goiânia, oferecendo uma experiência completa de compras com as melhores marcas e serviços.",
    services: ["Shopping Center", "Lojas de Moda", "Praça de Alimentação", "Entretenimento"]
  },
  {
    id: 2,
    name: "Montreal Indústria",
    category: "Industrial",
    description: "Indústria de alta qualidade focada na produção e distribuição de produtos industriais para todo o Centro-Oeste brasileiro.",
    services: ["Produção Industrial", "Distribuição", "Logística", "Controle de Qualidade"]
  },
  {
    id: 3,
    name: "NM Construtora",
    category: "Construção Civil",
    description: "Construtora especializada em projetos residenciais e comerciais, com foco na qualidade, prazo e satisfação do cliente.",
    services: ["Construção Residencial", "Projetos Comerciais", "Incorporação", "Gerenciamento de Obras"]
  }
];

export const contactInfo = {
  address: "Goiânia, Goiás - Brasil",
  phone: "(62) 98599-0009",
  email: "contato@grupomrp.com.br",
  businessHours: "Segunda a Sexta: 8h às 18h"
};